import groupBy from 'lodash/groupBy';
import head from 'lodash/head';
import uniqBy from 'lodash/uniqBy';

import { ProductHistory } from '@savgroup-front-common/types';

import { AdaptedNeededInformation } from '../AdditionalInformationExpect.types';

export const groupProductsBy =
  <
    T extends {
      productHistory?: ProductHistory[];
      ownerProductId?: string;
      neededInformation: AdaptedNeededInformation[];
    },
  >({
    fieldName,
  }: {
    fieldName: string;
  }) =>
  (products: T[]) => {
    const groupedProductsByFieldName = groupBy(products, fieldName);

    return Object.values(groupedProductsByFieldName).map(
      (groupedProducts = []) => {
        const productHistory = groupedProducts.map(
          (groupedProduct) => groupedProduct?.productHistory || [],
        );
        const flattenProductHistory = productHistory.flat();

        return {
          ...head(groupedProducts),
          ownerProductId: groupedProducts.map(
            ({ ownerProductId }) => ownerProductId,
          ),
          ownerProductIds: groupedProducts.map(
            ({ ownerProductId }) => ownerProductId,
          ),
          neededInformation: groupedProducts.reduce<AdaptedNeededInformation[]>(
            (acc, groupedProduct) => {
              return [...acc, ...(groupedProduct.neededInformation || [])];
            },
            [],
          ),
          quantity: groupedProducts.length,
          productHistory: uniqBy(flattenProductHistory, 'fileId'),
        };
      },
    );
  };
